<ion-header>
  <ion-toolbar>
    <div class="selectFoodHeading">
      <ion-title>{{'library.exerciseSelect.title' | translate}}</ion-title>
    </div>
    <ion-buttons slot="end">
      <ion-button (click)="cancel()" class="closeBtn ">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-row class="bottom-select-panel">
    <ion-col>
      <div class="selected-users">
        <p class="members-list" *ngIf="selectedExercises.length > 0">
          <ion-chip outline="" color="primary" *ngFor="let exercise of selectedExercises" (click)="removeExercise(exercise.id)">
            <ion-label>{{exercise.title}}</ion-label>
            <ion-icon name="close-circle" role="img"></ion-icon>
          </ion-chip>
        </p>
      </div>
    </ion-col>
  </ion-row>
</ion-header>

<ion-content class="ion-padding">

  <div class="loading" *ngIf="!filteredExercises">
    <ion-spinner name="lines"></ion-spinner>
  </div>

  <!-- Sort By Title -->
  <ion-grid *ngIf="!loading">
    <ion-row class="wp-filterMainPanel">
      <ion-col class="client-info">
        <div class="search">
          <ion-searchbar [(ngModel)]="activeFilters.searchTerm" (ionInput)="filterChanged()" debounce="300" [placeholder]="'general.search' | translate"></ion-searchbar>
        </div>

        <div class="header-filters">
          

          <!-- Equipment -->
          <mat-select multiple class="formControl equipment filter placeholder-white" panelClass="filterPanel" #equip="ngModel" [(ngModel)]="activeFilters.equipment" (selectionChange)="filterChanged('equipment')" name="equipment" *ngIf="equipment" [placeholder]="'general.all' | translate">
            <ng-container *ngFor="let item of equipment">
              <ng-container *ngIf="!item.children || item.children.length === 0">
                <mat-option class="optParent" [value]="item.value">{{item.name}}</mat-option>
              </ng-container>
              <ng-container *ngIf="item.children?.length > 0">
                <div class="parentWrapper">
                  <div class="left">
                    {{item.name}}
                  </div>
                  <div class="right">
                    <span (click)="selectAll('equipment', item.value);">{{'general.all' | translate}}</span>
                    <span class="white">&#8226;</span>
                    <span (click)="clearAll('equipment', item.value);">{{'general.clear' | translate}}</span>
                  </div>
                </div>
                <ng-container *ngFor="let child of item.children">
                  <mat-option class="optChild" [value]="child.value">{{child.name}}</mat-option>
                  <ng-container *ngIf="child.children?.length > 0">
                    <ng-container *ngFor="let grand of child.children">
                      <mat-option class="optGrandChild" [value]="grand.value">{{grand.name}}</mat-option>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>
          </mat-select>

          <!-- Body Parts -->
          <mat-select multiple class="formControl bodyParts filter placeholder-white" panelClass="filterPanel" #bodyPart="ngModel" [(ngModel)]="activeFilters.bodyPart" (selectionChange)="filterChanged($event)" name="bodyPart" *ngIf="options.mode !== 'cardio' && bodyParts" [placeholder]="'general.all' | translate">
            <ng-container *ngFor="let item of bodyParts">
              <ng-container *ngIf="!item.children || item.children.length === 0">
                <mat-option class="optParent" [value]="item.value">{{item.name}}</mat-option>
              </ng-container>
              <ng-container *ngIf="item.children?.length > 0">
                <div class="parentWrapper">
                  <div class="left">
                    {{item.name}}
                  </div>
                  <div class="right">
                    <span (click)="selectAll('bodyPart', item.value);">{{'general.all' | translate}}</span>
                    <span class="white">&#8226;</span>
                    <span (click)="clearAll('bodyPart', item.value);">{{'general.clear' | translate}}</span>
                  </div>
                </div>
                <ng-container *ngFor="let child of item.children">
                  <mat-option class="optChild" [value]="child.value">{{child.name}}</mat-option>
                  <ng-container *ngIf="child.children?.length > 0">
                    <ng-container *ngFor="let grand of child.children">
                      <mat-option class="optGrandChild" [value]="grand.value">{{grand.name}}</mat-option>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>
          </mat-select>

          <!-- Type -->
          <mat-select multiple class="formControl exerciseType filter placeholder-white" #type="ngModel" [(ngModel)]="activeFilters.exerciseType" (selectionChange)="filterChanged()" name="exerciseType" *ngIf="options.mode !== 'cardio' && exerciseTypes" [placeholder]="'general.all' | translate">
            <ng-container *ngFor="let item of exerciseTypes">
              <mat-option class="optParent" [value]="item.value">{{item.name}}</mat-option>
              <ng-container *ngIf="item.children?.length > 0">
                <ng-container *ngFor="let child of item.children">
                  <mat-option class="optChild" [value]="child.value">{{child.name}}</mat-option>
                  <ng-container *ngIf="child.children?.length > 0">
                    <ng-container *ngFor="let grand of child.children">
                      <mat-option class="optGrandChild" [value]="grand.value">{{grand.name}}</mat-option>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>
          </mat-select>

          <!-- Sort By -->
          <mat-select class="formControl sortBy filter" #indexName="ngModel" [(ngModel)]="activeIndex" (selectionChange)="indexChange()" name="indexName">
            <mat-option value="exercises_elitetrainr">{{'general.title' | translate}}</mat-option>
            <mat-option value="exercises_counter_elitetrainr">{{'general.mostUsed' | translate}}</mat-option>
          </mat-select>
        </div>
        <div class="panel">

          <!-- Navbar -->
          <nav mat-tab-nav-bar *ngIf="showNav">
            <a mat-tab-link (click)="setFilterType('system')" [active]="activeFilters.type === 'system'">{{'general.publicLibrary' | translate}}</a>
            <a mat-tab-link (click)="setFilterType('custom')" [active]="activeFilters.type === 'custom'">{{'library.exerciseSelect.myExercises' | translate}}</a>
            <a mat-tab-link (click)="setFilterType('recents')" [active]="activeFilters.type === 'recents'">{{'library.exerciseSelect.recentlyUsed' | translate}}</a>
          </nav>

          <div class="panel-body">
            <!-- Algolia Filters -->
            <ng-container *ngIf="activeFilters.type !== 'recents'">
              <div class="ais-Hits-list" *ngIf="hits?.length">
                <div class="exercise-item" *ngFor="let exercise of hits">
                  <exercise-card [exerciseObj]="exercise" [userEquipmentList]="equipmentList" (click)="selectExercise(exercise)"></exercise-card>
                </div>
              </div>
            </ng-container>

            <!-- Recently Used -->
            <ng-container *ngIf="activeFilters.type === 'recents'">

              <!-- Loading -->
              <div class="loading" *ngIf="!recentExercisesLoaded">
                <ion-spinner name="lines-small"></ion-spinner>
              </div>

              <div *ngIf="recentExercisesLoaded">
                <!-- No Recents -->
                <div class=" text-center" *ngIf="!recentExercises">{{'library.exerciseSelect.noRecentExercises' | translate}}</div>

                <!-- Recents -->
                <div *ngIf="recentExercises?.length > 0">
                  <div class="exercise-item" *ngFor="let exercise of recentExercises">
                    <exercise-card [exerciseObj]="exercise" [userEquipmentList]="equipmentList"  (click)="selectExercise(exercise)"></exercise-card>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>


  <ion-infinite-scroll threshold="100px" [disabled]="!hasMore || activeFilters.type === 'recents'" (ionInfinite)="loadData($event)">
    <ion-infinite-scroll-content loadingSpinner="bubbles" [loadingText]="'library.exerciseSelect.loadingExercises' | translate">
    </ion-infinite-scroll-content>
  </ion-infinite-scroll>

</ion-content>

<ion-footer *ngIf="multiple">
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button fill="solid" color="secondary" (click)="done()" size="small" [disabled]="!selectedExercises || selectedExercises.length === 0">
        {{'library.exerciseSelect.addExercises' | translate}}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>

<ng-template #recursiveListTmpl let-list="list" let-name="name">
  <ng-container *ngFor="let item of list">
      <mat-option value="{{item.value}}">{{item.name}} {{item.value}}</mat-option>
      <ng-container *ngIf="item.children?.length > 0">
        <ng-container *ngTemplateOutlet="recursiveListTmpl; context:{ list: item.children, name: name }"></ng-container>
      </ng-container>
  </ng-container>
</ng-template>